import { StandingAccessReportAppModel } from '@api';

export const AssessmentReportStatus = {
  InProgress: 'InProgress',
  Ready: 'Ready',
  ReAssess: 'ReAssess',
  Error: 'Error',
  Warning: 'Warning',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AssessmentReportStatus = (typeof AssessmentReportStatus)[keyof typeof AssessmentReportStatus];

export interface StandingAccessReportIntegration {
  id: string;
  name: string;
  type: string;
  typeIcon: string;
}

export interface StandingAccessReportItem {
  report: StandingAccessReportAppModel;
  integration?: StandingAccessReportIntegration;
}

export const cloudProviders = [
  {
    type: 'aws-organization',
    name: 'AWS Organizations',
    description: 'We currently support only AWS organizations. ',
    icon: 'https://slack-cdn.apono.io/integrations/aws.svg',
    resourceType: 'aws-organization-account',
  },
  {
    type: 'gcp-organization',
    name: 'Google Cloud Platform',
    description: 'Be the first to know when we launch',
    icon: 'https://slack-cdn.apono.io/integrations/google-cloud-role.svg',
    resourceType: 'gcp-project',
    disabled: true,
  },
  {
    type: 'azure-management-group',
    name: 'Microsoft Azure',
    description: 'Be the first to know when we launch',
    icon: 'https://slack-cdn.apono.io/integrations/azure-management-group.png',
    disabled: true,
    resourceType: 'azure-subscription',
  },
];

export const REPORT_ITEM_PARAM = 'reportItem';

export const REPORT_TIER_TO_REMEDIATE_PARAM = 'tierToRemediate';

export const FORCE_REVOKE_PARAM = 'forceRevoke';

export const ReportTierOptions = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ReportTierOptions = (typeof ReportTierOptions)[keyof typeof ReportTierOptions];

export function isReportTierOptions(value: string): value is ReportTierOptions {
  return Object.values(ReportTierOptions).includes(value as ReportTierOptions);
}

export const TIER_SCORE_MAP: Record<ReportTierOptions, number> = {
  Critical: 50,
  High: 25,
  Medium: 15,
  Low: 10,
};

export const TIER_DESCRIPTION: Record<ReportTierOptions, string> = {
  Critical: 'Unused in 90 days / High risk',
  High: 'Used in 90 days / High risk',
  Medium: 'Unused in 90 days / Low risk',
  Low: 'Used in 90 days / Low risk',
};

export const ASSESSMENT_REPORT_BOOLEAN_FILTER_OPTION = {
  yes: 'yes',
  no: 'no',
} as const;

export const ASSESSMENT_REPORT_RESOURCES_FILTER = {
  label: 'Accounts',
  param: 'resources',
} as const;

export const ASSESSMENT_REPORT_RISK_SCORE_FILTER = {
  label: 'Risk Score',
  param: 'risk_score',
} as const;

export const ASSESSMENT_REPORT_PERMISSIONS_FILTER = {
  label: 'Entitlements',
  param: 'permissions',
} as const;

export const ASSESSMENT_REPORT_LINKED_ELEMENTS_FILTER = {
  label: 'Connected Identities',
  param: 'linkedElements',
} as const;

export const ASSESSMENT_REPORT_IN_ACCESS_FLOW_FILTER = {
  label: 'In Access Flow',
  param: 'inAccessFlow',
} as const;

export const ASSESSMENT_REPORT_REVOKED_FILTER = {
  label: 'Revoked',
  param: 'revoked',
} as const;

export const ASSESSMENT_REPORT_TIER_FILTER = {
  label: 'Risk Tier',
  param: 'tier',
} as const;
